window.UpdateCollectionDateConfirm = (function() {
    window.dataLayer = window.dataLayer || [];

    let self = {
        urls: {
            removeCollectionDateSession: '/api/sitecore/UpdatePremiumBankCollection/RemoveCollectionDateSession',
            redirectUrl: '/my-account/security'
        },
        func: {
            init: function() {
                self.func.bindings();
            },
            bindings: function() {
                $('#request-submitted-button').on('click', self.func.removeSessionAndRedirect);
            },
            removeSessionAndRedirect: function() {
                $.post(self.urls.removeCollectionDateSession)
                    .done(function() {
                        window.location.href = self.urls.redirectUrl;
                    });

            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function() {
        if ('request-submitted-section' === $('#request-submitted-section').data('feature')) {
        window.UpdateCollectionDateConfirm.Init();
    }
});
